import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustSection } from '../components/TrustSection';
import { PopularProducts } from '../components/PopularProducts';
import { ProductCategories } from '../components/ProductCategories';
import { NeoLifeQuality } from '../components/NeoLifeQuality';
import { AllProducts } from '../components/AllProducts';
export function HomePage() {
  return <main data-id="element-412">
      <HeroSection data-id="element-413" />
      <TrustSection data-id="element-414" />
      <PopularProducts data-id="element-415" />
      <ProductCategories data-id="element-416" />
      <NeoLifeQuality data-id="element-417" />
      <AllProducts data-id="element-418" />
    </main>;
}